<div class="playback-in-out-points-content">
  <!-- <div class="playback-in-out-title">Manual Upload</div> -->
  <div class="playback-in-out">
    <!-- Action -->
    <div class="button-actions">
      @if (actions.max.show) {
        <div class="button" [class.secondary]="!actions.max.done" [class.disabled]="!actions.max.enabled || actions.max.done" (click)="upload('maxStartManualUpload')">Upload MAX</div>
      }
      @if (actions.maxParity.show) {
        <div class="button" [class.secondary]="!actions.maxParity.done" [class.disabled]="!actions.maxParity.enabled || actions.maxParity.done" (click)="upload('maxParityStartManualUpload')">Upload MAX Parity</div>
      }
      @if (actions.vod.show) {
        <div class="button" [class.secondary]="!actions.vod.done" [class.disabled]="!actions.vod.enabled || actions.vod.done" (click)="upload('vodStartManualUpload')">Upload VOD</div>
      }
      @if (actions.linear.show) {
        <div class="button" [class.secondary]="!actions.linear.done" [class.disabled]="!actions.linear.enabled || actions.linear.done" (click)="upload('linearStartManualUpload')">Upload Linear</div>
      }
      @if (actions.contentAcquisition.show) {
        <div class="button" [class.secondary]="!actions.contentAcquisition.done" [class.disabled]="!actions.contentAcquisition.enabled || actions.contentAcquisition.done" (click)="upload('contentAcquisitionStartManualUpload')">Upload Content Acquisition</div>
      }
      @if (actions.archive.show) {
        <div class="button" [class.secondary]="!actions.archive.done" [class.disabled]="!actions.archive.enabled || actions.archive.done" (click)="upload('archiveStartManualUpload')">Upload Archive</div>
      }
    </div>
  </div>
</div>